<template>
  <header class="header">
    <div class="container">
      <img class="brand-logo" src="img/logos/yual.svg" alt="yual_logo" title="yual - Full Cycle Development Company">
      <div class="burger" :class="{ 'active': menu }" @click="toggleMenu()">
          <span></span>
          <span></span>
          <span></span>
          <span></span>
      </div>
    </div>
    <div class="menu" :class="{ 'active': menu }">
      <div class="container">
        <div class="menu_content">
          <ul class="menu_list">
            <!-- <li class="menu_list_item"><a href="#">services</a></li>
            <li class="menu_list_item"><a href="#">our work</a></li>
            <li class="menu_list_item"><a href="#">careers</a></li>
            <li class="menu_list_item"><a href="#">contact us</a></li> -->
          </ul>

          <div class="menu_links">
            <a href="tel:+380958329869" title="Call to us now!">+380958329869</a>
            <a href="mailto:info@yual.io" title="Contact us now!">info@yual.io</a>
            <!-- <a href="#">Blog</a>
            <a href="#">Events</a> -->
          </div>

          <div class="social">
            <a href="https://www.behance.net/yual_studio" target="_blank" rel="noreferrer">
              <img src="img/icons_custom/behance.svg" loading="lazy" alt="behance" title="Our Behance portfolio here">
            </a>
            <a href="https://www.linkedin.com/company/yual" target="_blank" rel="noreferrer">
              <img src="img/icons_custom/linkedin.svg" loading="lazy" alt="linkedin" title="Our business profile on LinkedIn">
            </a>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import { TimelineMax, TweenMax } from 'gsap';

export default {
  name: 'HeaderComponent',
  data: () => ({
    menu: false
  }),
  methods: {
    toggleMenu () {
      this.menu = !this.menu;
      var tl1 = new TimelineMax();
      if (this.menu === true) {
        // TweenMax.set(('.menu_list_item'), { opacity: 0, x: 100 })
        TweenMax.set(('.menu_links a'), { opacity: 0, x: 100 });
        TweenMax.set(('.social a'), { opacity: 0, y: 100 });
        tl1
          // .staggerTo(('.menu_list_item'), 0.3, { opacity: 1, x: 0 }, 0.25)
          .staggerTo(('.menu_links a'), 0.3, { opacity: 1, x: 0 }, 0.25)
          .staggerTo(('.social a'), 0.3, { opacity: 1, y: 0 }, 0.25);
      }
    }
  },
  mounted () {
    var tl = new TimelineMax();
    tl
      .to(('.brand-logo'), 0.3, { opacity: 1, x: 0 }, '+=0.5')
      .to(('.burger'), 0.5, { opacity: 1, x: 0 }, '-=1');
  }
};
</script>

<style lang="scss">

</style>
